import React, { useContext, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@hookform/error-message';
import { useForm } from 'react-hook-form';
import Countdown from 'react-countdown';
import Cookies from 'universal-cookie';
import { Context } from "../../components/Context";
import { SIGN_IN, VERIFY_OTP, fetchData } from "../../components/Service";

export default function Login() {
    const { t } = useTranslation();
    const cookies = new Cookies();
    window.document.title = `${t('Login')} | ${t('Panda')}`;

    let lng = "en";
    if (cookies.get('lng') && cookies.get('lng') !== undefined) {
        lng = cookies.get('lng');
    }

    const { handleSubmit, register, setValue, setFocus, setError, formState: { errors }, } = useForm();
    let [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const [context, setContext] = useContext(Context);
    const [reload, setReload] = useState(false);
    const [showOTP, setShowOTP] = useState(false);

    const [resendOTP, setResendOTP] = useState(false);
    const [data, setData] = useState({ date: Date.now(), delay: 120000 });

    async function onLoginSubmit(data) {
        setReload(true);

        let mobile_no = data.mobile;

        await fetchData(SIGN_IN, 'POST', { user: { mobile: mobile_no } }, false, false, (res) => {
            if (res.status === true) {
                setContext({ ...res.data, mobile_no: mobile_no })

                setShowOTP(true)
                resetTimer()
                setFocus("otp1", { shouldSelect: true });
            } else {
                setFocus("mobile", { shouldSelect: true })
                res.error && res.error.message && setError('mobile', { type: 'custom', message: t(res.error.message) });
            }

            setValue("mobile", '')
            setReload(false)
        });
    }

    async function verifyOtp(data) {
        try {
            const OTP = `${data.otp1}${data.otp2}${data.otp3}${data.otp4}`

            const formdata = {
                verify_id: context && context.verify_id,
                code: OTP
            };

            if (resendOTP) {
                setError('otp1', { type: 'custom', message: t('Verification expired.') });
                return false;
            }

            setReload(true);

            fetchData(VERIFY_OTP, 'POST', formdata, false, false, (res) => {
                if (res.status && res.data) {
                    const cookies = new Cookies();
                    const userInfo = { ...context, ...res.data.user };

                    let expirydate = new Date();
                    expirydate.setDate(expirydate.getDate() + 1);

                    setContext(userInfo);

                    cookies.set(
                        'user', userInfo, {
                        path: '/',
                        expires: expirydate
                    }
                    );

                    if (res.data.user.request_profile_confirmation && (context && !context.is_loyalty_customer)) {
                        navigate('/admin/registration')
                    } else {
                        navigate('/admin/dashboard')
                    }
                } else {
                    res.error && res.error.message && setError('otp1', { type: 'custom', message: t(res.error.message) });
                }
                setReload(false);
            });
        } catch (err) {
            setError('otp1', { type: 'custom', message: t('Invalid action perform') });
        }
    }

    async function resendVerifyOtp() {
        setResendOTP(false);
        resetTimer();

        if (context && context.mobile_no) {
            onLoginSubmit({ mobile: context.mobile_no })
        } else {
            setError('otp1', { type: 'custom', message: t('Something went wrong') });
        }
    }

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            setResendOTP(true);
            return <span>0</span>
        } else {
            if (seconds === 0) {
                seconds = `${seconds}0`;
            }
            return <span>{minutes}:{seconds}</span>
        }
    };

    const handleEnter = (target) => {
        if (target.name === 'otp1')
            setFocus("otp2", { shouldSelect: true })
        if (target.name === 'otp2')
            setFocus("otp3", { shouldSelect: true })
        if (target.name === 'otp3')
            setFocus("otp4", { shouldSelect: true })
    }

    const resetTimer = () => {
        setData({ date: Date.now(), delay: 120000 });
    };

    const changeMobileNo = () => {
        setShowOTP(false)
        setContext()
    }

    return (
        <>
            <section className="banner-landing">
                <div className="container py-3">
                    <div className="row d-flex justify-content-center align-items-center shadow position-lft-right rounded-10">
                        <div className="col-md-5">
                            <div className="text-center p-5">
                                <h2 className='mb-3'>{t('Start Saving')}</h2>

                                {(showOTP && context && context.verify_id) ?
                                    <>
                                        <p>{t('Please verify OTP')}</p>
                                        <p>{context && context.mobile_no}</p>
                                    </>
                                    : <>
                                        <p>{t('Enjoy member exclusive offers')}</p>
                                        <p>{t('Instant and Guaranteed')}</p>
                                    </>
                                }

                                {!showOTP && <form className="mt-4 pass-word" id="loginForm" onSubmit={handleSubmit(onLoginSubmit)}>
                                    <div className="input-group mt-2">
                                        <input type='number' {...register('mobile', {
                                            pattern: {
                                                value: /^5[0-9]{8}$/,
                                                message: `${t('Enter valid No')}`,
                                            },
                                            required: `${t('Required field')}`
                                        })} className='home-form-control form-control' placeholder={t('Mobile number xxx')}/>
                                        <ErrorMessage errors={errors} name="mobile" render={({ message }) => <p className='error-message'>{message}</p>} />
                                    </div>

                                    <button type="submit" className="mt-3 py-3 px-5 text-white fw-bold btn-theme" disabled={reload}>
                                        {reload && <span className="spinner-border spinner-border-sm mr-1"></span>} {t('Submit')}
                                    </button>
                                </form>}

                                {showOTP && context && context.verify_id && <form className="mt-4 pass-word" id="verifyOtp" onSubmit={handleSubmit(verifyOtp)}>
                                    <div className="input-group mt-2 mx-auto">
                                        <div className="otp-input-root mx-auto" style={{ display: 'flex', direction: 'ltr' }}>
                                            <input type="tel" {...register('otp1', { required: `${t('Required field')}` })} onKeyUp={(e) => handleEnter(e.target)} maxLength="1" className="inputs60X60 otp-input home-form-control form-control" />
                                            <input type="tel" {...register('otp2', { required: `${t('Required field')}` })} onKeyUp={(e) => handleEnter(e.target)} maxLength="1" className="inputs60X60 otp-input home-form-control form-control" />
                                            <input type="tel" {...register('otp3', { required: `${t('Required field')}` })} onKeyUp={(e) => handleEnter(e.target)} maxLength="1" className="inputs60X60 otp-input home-form-control form-control" />
                                            <input type="tel" {...register('otp4', { required: `${t('Required field')}` })} onKeyUp={(e) => handleEnter(e.target)} maxLength="1" className="inputs60X60 otp-input home-form-control form-control p-left-2" />
                                        </div>
                                    </div>
                                    <ErrorMessage errors={errors} name="otp1" render={({ message }) => <p className='error-message'>{message}</p>} />

                                    <button type="submit" className="mt-3 py-3 px-5 text-white fw-bold btn-theme" disabled={reload}>
                                        {reload && <span className="spinner-border spinner-border-sm mr-1"></span>} {t('Verify OTP')}
                                    </button>

                                    {resendOTP ? <span type="button" className='text-dark-green mt-2 w-100' onClick={() => resendVerifyOtp()}>{t('Resent OTP')}</span>
                                        : <h6 className='pt-2'><span className='text-dark-green fs-6 fw-lighter'>{t('Please wait for')}
                                            <span className='text-danger'>
                                                <Countdown date={data.date + data.delay} renderer={renderer} />
                                            </span> {t('Seconds remaining')}
                                        </span></h6>}


                                    <span type="button" className='text-dark-green mt-2' onClick={() => changeMobileNo()}>{t('Change Mobile Number')}</span>
                                </form>}
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="panda-image">
                                <img src={t('Images.loyalty_card')} alt="" />
                            </div>
                        </div>
                        <div className={`${lng}-img d-none`}>
                            <img src={t('Images.hero_bottom_left')} className="top_left rounded-10" alt={`hero-bottom-left-${lng}`} />
                            <img src={t('Images.hero_top_right')} className="bootom_right rounded-10" alt={`hero-top-right-${lng}`} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="second py-1">
                <div className="container p-0">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ratio ratio-21x9 shadow rounded-10">
                                <iframe width="100%" height="" src="https://www.youtube.com/embed/e-s23yh1uPY"
                                    title="YouTube video player" frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen className="rounded-10">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="third">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row d-flex justify-content-center align-items-center shadow get_pandaplus rounded-10">
                                <div className="col-md-7 py-sm-5">
                                    <div className="get-content_right p-5">
                                        <h5 className="fw-bold text-white pt-">{t('Get Panda plus')}</h5>
                                        <p className="text-white">
                                            {t('Shop from the comfort')}
                                        </p>
                                        <div className="d-flex  pt-3">
                                            <a href="https://apps.apple.com/us/app/pandaclick-%D8%A8%D9%86%D8%AF%D9%87-%D9%83%D9%84%D9%8A%D9%83/id1059989053" target="_blank"><img src="/images/app-store.png" className="button-image pe-3" alt="app-store" /></a>
                                            <a href="https://play.google.com/store/apps/details?id=com.todoorstep.store" target="_blank"><img src="/images/play-store.png" className="button-image pe-3" alt="app-store" /></a>
                                            <a href="https://appgallery.huawei.com/#/app/C102405765" target="_blank"><img src="/images/huawei-download-panda-app.png" className="button-image pe-3" alt="app-store" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 p-0">
                                    <div className="getpanda-img">
                                        <div className={`${lng}-img d-none ${lng === 'ar' && 'text-start'}`}> <img src={t('Images.cta_basket')} className="rounded-10" alt={`cta-food-basket-${lng}`} /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
